import React from "react";
import { ArrowRightIcon, CircleCheckBigIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/links";
type CTAButtonProps = {
  label: string;
  id?: string;
  note?: string;
  tone?: "light" | "dark";
};
export function CTAButton({
  label,
  id,
  note,
  tone = "light"
}: CTAButtonProps) {
  return <div className="mx-auto w-full max-w-xl text-center" data-id="element-31" data-mp="2fyjx33ox7ed1">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-[15px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_#136a37] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-ctadark active:translate-y-[4px] active:shadow-[0_2px_0_#136a37] focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-2 focus-visible:outline-goldlight sm:py-6 sm:text-lg" data-id="element-32" data-mp="2tzctjtys8jis">
        <CircleCheckBigIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-33" data-mp="38pabhs64cczj" />
        <span className="text-balance" data-id="element-34" data-mp="199en4nqxysky">{label}</span>
        <ArrowRightIcon className="hidden h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:block" aria-hidden="true" data-id="element-35" data-mp="19apoyi0ttq9f" />
      </a>
      {note && <p className={`mt-4 text-sm leading-relaxed ${tone === "dark" ? "text-white/70" : "text-ink/60"}`} data-id="element-36" data-mp="1ibxof3f2wx53">
          {note}
        </p>}
    </div>;
}